import axios from 'axios';
import dayjs from 'dayjs';

import {
  EMPLOYEE_LEAVE_REQUESTS,
  EMPLOYEES_WORK_AGREEMENTS,
  PUBLIC_DUTY_HOUR_TYPES
} from 'RestAPIs/endpoints';

export interface EmployeeLeaveRequestsValues {
  employeeId: number;
  status?: string;
}

export interface NewEmployeeLeaveRequest {
  dutyTypeId: number;
  empNote: string;
  valid: {
    from: Date;
    to: Date;
  };
  waId: number;
}

export interface PublicDutyHourTypesValues {
  id: number;
  dutyTypeId: number;
  description: string;
}

export interface WorkAgreementValues {
  startDate: Date;
  endDate: Date;
  employeeId: number;
}

export interface WorkAgreementResponse {
  nr: number;
  functionDescription: string;
  brName: string;
  contractKind: string;
  brNameShort: string;
  waId: number;
  validTo: Date;
  validFrom: Date;
}

export const getEmployeeLeaveRequests = (employeeId: number) =>
  axios.get<EmployeeLeaveRequestsValues[]>(
    `${EMPLOYEE_LEAVE_REQUESTS}?empId=${employeeId}`
  );

export const addEmployeeLeaveRequest = (body: NewEmployeeLeaveRequest) =>
  axios.post<EmployeeLeaveRequestsValues>(EMPLOYEE_LEAVE_REQUESTS, body);

export const removeEmployeeLeaveRequest = (leaveRequestId: number) =>
  axios.delete<EmployeeLeaveRequestsValues[]>(
    `${EMPLOYEE_LEAVE_REQUESTS}/${leaveRequestId}`
  );

export const getPublicDutyHourTypes = () =>
  axios.get<PublicDutyHourTypesValues[]>(
    `${PUBLIC_DUTY_HOUR_TYPES}?group=leave-requests`
  );

export const getWorkAgreements = ({
  startDate,
  endDate,
  employeeId
}: WorkAgreementValues) =>
  axios.get<WorkAgreementResponse[]>(EMPLOYEES_WORK_AGREEMENTS, {
    params: {
      startDate: dayjs(startDate).toISOString(),
      endDate: dayjs(endDate).toISOString()
    },
    pathParams: {
      employeeId
    }
  });
